import { Option } from '../../types/common/option';

export const flexSpaceNames: Option[] = [
    { label: 'Hot Desks', value: 'hot', order: 1 },
    { label: 'Fixed Desks', value: 'fixed', order: 2 },
    { label: 'Serviced Offices', value: 'serviced', order: 3 }
];